
import axios from "axios";
const axiosInstance = axios.create({
  // baseURL: "https://api-uat.rentexcel.com/", //35.154.66.81
  baseURL: "https://api-uat.taprootcrm.com/",
  // baseURL: "http://192.168.0.181:4567",
  
  // baseURL: "http://192.168.1.10:4567", // HK
});

// Set document title dynamically based on the active API URL
if (axiosInstance.defaults.baseURL && axiosInstance.defaults.baseURL.includes("rentexcel")) {
  document.title = "CC RentExcel CRM";
} else {
  document.title = "CC Taproot CRM";
}

// Add a request interceptor to attach the token from localStorage
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); // Retrieve the token from localStorage
  if (token) {
    config.headers["Authorization"] = `Token ${token}`; // Add the token to the request headers
  }

  // config.headers["domain"] = "uat.taprootcrm.com";
  config.headers["domain"] = "central";
  // config.headers["domain"] = window.location.hostname.replace(
  //   /\bdashboard.\b/g,
  //   ""
  // );
  return config;
});

export default axiosInstance;
